import { queryOptions } from "@tanstack/react-query";
import { getOrganization } from "./index";

export const organizationQueries = {
  rootKey: () => ["organization"],

  getOrganization: () =>
    queryOptions({
      queryKey: [...organizationQueries.rootKey(), "getOrganization"],
      queryFn: () => getOrganization(),
    }),
}; 